module.exports = __webpack_public_path__ + "img/daycohost.7de1b151.png";